import axiosInstance from "../../utils/axiosCompany";

export const getDailyData = async (values) => {
    return await axiosInstance().post("company/dashboard/get-daily-data", values);
}
export const getAllLoggedInUser = async (values) => {
    return await axiosInstance().post("company/dashboard/get-all-loggedIn-user", values);
}
export const getTodaysOrders = async (values) => {
    return await axiosInstance().post("company/dashboard/get-todays-orders", values);
}
export const getTodaysTransactions = async (values) => {
    return await axiosInstance().post("company/dashboard/get-todays-transactions", values);
}

export const getDashboardKpis = async (values) => {
    return await axiosInstance().post("company/dashboard/kpis", values);
}

export const getRevenueTrend = async (values) => {
    return await axiosInstance().post("company/dashboard/revenue-trend", values);
}

export const getOrderModeSplit = async (values) => {
    return await axiosInstance().post("company/dashboard/order-mode-split", values);
}

export const getPaymentMethodSplit = async (values) => {
    return await axiosInstance().post("company/dashboard/payment-method-split", values);
}

export const getBrandSplit = async (values) => {
    return await axiosInstance().post("company/dashboard/brand-split", values);
}
// aggregator orders split by aggregator (grouped by its sku, the same across brands):
// rows of { aggregator, count, revenue }
export const getAggregatorSplit = async (values) => {
    return await axiosInstance().post("company/dashboard/aggregator-split", values);
}

export const getPeakHours = async (values) => {
    return await axiosInstance().post("company/dashboard/peak-hours", values);
}

export const getTopMenuItems = async (values) => {
    return await axiosInstance().post("company/dashboard/top-menu-items", values);
}

export const getTopOutlets = async (values) => {
    return await axiosInstance().post("company/dashboard/top-outlets", values);
}

export const getTopCustomers = async (values) => {
    return await axiosInstance().post("company/dashboard/top-customers", values);
}
